import { render, staticRenderFns } from "./app.vue?vue&type=template&id=d071c078&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&id=d071c078&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NotificationsWrapper: require('/app/components/NotificationsWrapper.vue').default,AppBar: require('/app/components/AppBar.vue').default,BottomNavigation: require('/app/components/BottomNavigation.vue').default})
